import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";
import { HELPERS } from "consts";
import { bindActionCreators } from "redux";

import { decodeHandler, forbidExtraProps, objectToArray } from "utils";
import { changeFRTargetMachine, changeIRTargetMachine } from "store/actions";
import { useEffect } from "react";

function RestoreMachines(props) {
  const clientUUID = props.location.pathname.split("/")[
    props.location.pathname.split("/").length - 2
  ];

  let dropDownList = [];

  objectToArray(props.clients.list).map((val, i) => {
    if (dropDownList.length < 4) {
      if (val.isConfigured) {
        if (i < 3) dropDownList.push(val);
        else {
          if (dropDownList.includes(val)) {
            dropDownList.push(props.clients.list[clientUUID]);
            return;
          } else {
            dropDownList.push(val);
            return;
          }
        }
      }
    } else return;
  });

  useEffect(() => {
    props.changeFRTargetMachine(props.clients.list[clientUUID]);
    props.changeIRTargetMachine(props.clients.list[clientUUID]);
  }, [clientUUID]);

  return (
    <React.Fragment>
      {dropDownList.length > 0 && (
        <div className="machine_btn">
          {" "}
          {clientUUID &&
          objectToArray(props.clients.list).length > 0 &&
          props.clients.list[clientUUID]
            ? decodeHandler(props.clients.list[clientUUID].name)
            : ""}{" "}
        </div>
      )}
      {dropDownList.length > 0 && (
        <div className="machine_dropdown">
          <ul>
            {dropDownList.map((client, i) => (
              <li
                key={i}
                className={clientUUID === client.clientUUID ? "selected" : ""}
                onClick={() =>
                  props.history.push(
                    `/mirror/restore/${client.clientUUID}/file-restore`
                  )
                }
              >
                {decodeHandler(client.name)}
              </li>
            ))}
          </ul>
          <NavLink to="/mirror/restore">
            <div className="see-more-pc-btn">
              <div className="see-more">View All</div>
            </div>
          </NavLink>
        </div>
      )}
    </React.Fragment>
  );
}

RestoreMachines.propTypes = forbidExtraProps(
  {
    clients: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      list: PropTypes.object.isRequired
    }).isRequired
  },
  [...HELPERS.withRouter, "changeFRTargetMachine", "changeIRTargetMachine"]
);

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeFRTargetMachine,
      changeIRTargetMachine
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(React.memo(RestoreMachines)));
